function readRuntimeConfig () {
  if (typeof window === 'undefined') return {}
  return window.__RUNTIME_CONFIG__ || {}
}

function toStringOrEmpty (value) {
  if (value === null || value === undefined) return ''
  return String(value)
}

function trimSlashesEnd (value) {
  return value.replace(/\/+$/, '')
}

function trimSlashesStart (value) {
  return value.replace(/^\/+/, '')
}

export function joinUrl (baseUrl, path) {
  const base = trimSlashesEnd(toStringOrEmpty(baseUrl).trim())
  const subPath = trimSlashesStart(toStringOrEmpty(path).trim())

  if (!base) return subPath
  if (!subPath) return base

  return base + '/' + subPath
}

export function getRuntimeConfig () {
  const cfg = readRuntimeConfig()
  return {
    apiUrl: toStringOrEmpty(cfg.API_URL),
    hostUrl: toStringOrEmpty(cfg.HOST_URL),
    aiApi: toStringOrEmpty(cfg.AIAPI),
  }
}

export function getApiBaseUrl () {
  return getRuntimeConfig().apiUrl
}

export function getAiApiBaseUrl () {
  return getRuntimeConfig().aiApi
}

export function isAiEnabled () {
  const value = getAiApiBaseUrl()
  return value && value !== 'off'
}
